import actionTypes from './actionTypes'

const oeqActions = {
	addReferenceMediaOpenMenu() {
		return {
			type: actionTypes.OEQ_ADD_REFERENCE_MEDIA_OPEN_MENU,
		}
	},
	questionChange(value) {
		return {
			type: actionTypes.OEQ_QUESTION_CHANGE,
			value,
		}
	},
	deleteReferenceMedia(iconId) {
		return {
			type: actionTypes.OEQ_DELETE_REFERENCE_MEDIA,
			iconId,
		}
	},
	openSettingsModal() {
		return {
			type: actionTypes.OEQ_EDIT_SETTINGS,
		}
	},
	referenceMediaMenuOptionSelected(mediaType) {
		return {
			type: actionTypes.OEQ_REFERENCE_MEDIA_MENU_OPTION_SELECTED_PICKER_OPEN,
			mediaType,
		}
	},
	cancelOEQ() {
		return {
			type: actionTypes.OEQ_CANCEL_OEQ,
		}
	},
	cancelReject() {
		return {
			type: actionTypes.OEQ_CANCEL_OEQ_REJECTED,
		}
	},
	cancelOEQConfirm() {
		return {
			type: actionTypes.OEQ_CANCEL_OEQ_CONFIRM,
		}
	},
	cancelOEQConfirmed() {
		return {
			type: actionTypes.OEQ_CANCEL_OEQ_CONFIRMED,
		}
	},
	addTimer() {
		return {
			type: actionTypes.OEQ_ADD_TIMER,
		}
	},
	editTimer() {
		return {
			type: actionTypes.OEQ_EDIT_TIMER,
		}
	},
	deleteTimer() {
		return {
			type: actionTypes.OEQ_DELETE_TIMER,
		}
	},
	saveTimer(value) {
		return {
			type: actionTypes.OEQ_SAVE_TIMER,
			value,
		}
	},
	saveTimerError(previous_timer) {
		return {
			type: actionTypes.OEQ_TIMER_SAVE_ERROR,
			previous_timer,
		}
	},
	cancelTimer() {
		return {
			type: actionTypes.OEQ_CANCEL_TIMER,
		}
	},
	saveOEQ() {
		return {
			type: actionTypes.OEQ_SAVE_OEQ,
		}
	},
	saveOEQError(error) {
		return {
			type: actionTypes.OEQ_SAVE_OEQ_ERROR,
			error,
		}
	},
	saveOEQSuccess(redirectUrl, metrics) {
		return {
			type: actionTypes.OEQ_SAVE_OEQ_SUCCESS,
			redirectUrl,
			metrics,
		}
	},
	initializeOEQSuccess(data) {
		return {
			type: actionTypes.OEQ_INITIALIZE_SUCCESS,
			data,
		}
	},
	initializeOEQError() {
		return {
			type: actionTypes.OEQ_INITIALIZE_ERROR,
		}
	},
	questionSave() {
		return {
			type: actionTypes.OEQ_QUESTION_SAVE,
		}
	},
	questionUpdateError(error) {
		return {
			type: actionTypes.OEQ_QUESTION_UPDATE_ERROR,
			error,
		}
	},
	questionUpdateSuccess() {
		return {
			type: actionTypes.OEQ_QUESTION_UPDATE_SUCCESS,
		}
	},
	nearpodPickerCancel() {
		return {
			type: actionTypes.OEQ_NEARPOD_PICKER_CANCEL,
		}
	},
	uploadReferenceMedia(allowedTypes, files, featureType, force) {
		return {
			type: actionTypes.OEQ_UPLOAD_REFERENCE_MEDIA,
			allowedTypes,
			files,
			featureType,
			force,
		}
	},
	uploadReferenceMediaError(message) {
		return {
			type: actionTypes.OEQ_UPLOAD_REFERENCE_MEDIA_ERROR,
			message,
		}
	},
	uploaderUploadSuccess(icon) {
		return {
			type: actionTypes.OEQ_UPLOADER_UPLOAD_SUCCESS,
			icon,
		}
	},
	uploaderValidateSuccess(uploadId) {
		return {
			type: actionTypes.OEQ_UPLOADER_VALIDATE_SUCCESS,
			uploadId,
		}
	},
	uploaderUploadError(error, message) {
		return {
			type: actionTypes.OEQ_UPLOADER_UPLOAD_ERROR,
			error,
			message,
		}
	},
	uploaderValidateError(message) {
		return {
			type: actionTypes.OEQ_UPLOADER_VALIDATE_ERROR,
			message,
		}
	},
	uploaderValidateContentError(message) {
		return {
			type: actionTypes.OEQ_UPLOADER_VALIDATE_CONTENT_ERROR,
			message,
		}
	},
	requireUploadConfirmation() {
		return {
			type: actionTypes.OEQ_UPLOAD_REQUIRE_CONFIRMATION,
		}
	},
	deleteReferenceMediaSuccess() {
		return {
			type: actionTypes.OEQ_DELETE_REFERENCE_MEDIA_SUCCESS,
		}
	},
	validationError(message) {
		return {
			type: actionTypes.OEQ_VALIDATION_ERROR,
			message,
		}
	},
	validationSuccess(text) {
		return {
			type: actionTypes.OEQ_VALIDATION_SUCCESS,
			text,
		}
	},
	toggleStudentRecording(toggleValue) {
		return {
			type: actionTypes.OEQ_STUDENT_RECORDING_TOGGLE,
			value: toggleValue,
		}
	},
	openAudioRecorder() {
		return {
			type: actionTypes.OEQ_AUDIO_RECORDER_SELECTED,
		}
	},
	deleteAudioRecorder(hasAudioRecorded) {
		return {
			type: actionTypes.OEQ_AUDIO_RECORDER_DELETE_CONFIRM,
			hasAudioRecorded,
		}
	},
	cancelAudioRecorderDelete() {
		return {
			type: actionTypes.OEQ_AUDIO_RECORDER_DELETE_CANCELLED,
		}
	},
	confirmAudioRecorderDelete() {
		return {
			type: actionTypes.OEQ_AUDIO_RECORDER_DELETE_CONFIRMED,
		}
	},
	deleteAudioPlayer() {
		return {
			type: actionTypes.OEQ_AUDIO_PLAYER_DELETE_CONFIRM,
		}
	},
	cancelAudioPlayerDelete() {
		return {
			type: actionTypes.OEQ_AUDIO_PLAYER_DELETE_CANCELLED,
		}
	},
	confirmAudioPlayerDelete() {
		return {
			type: actionTypes.OEQ_AUDIO_PLAYER_DELETE_CONFIRMED,
		}
	},
}

export default oeqActions
